enum InventoryTabs {
  CUSTOM = 'custom',
  NA = 'na',
  EMEA = 'emea',
  GC = 'gc',
  APLA = 'apla',
}

export default InventoryTabs;
